module.exports = __webpack_public_path__ + "c347ffad793d8c34e943ba1899da886b.png";